import { render } from "./CardDescription.vue?vue&type=template&id=4ef3d9c5&scoped=true"
import script from "./CardDescription.vue?vue&type=script&lang=js"
export * from "./CardDescription.vue?vue&type=script&lang=js"

import "./CardDescription.vue?vue&type=style&index=0&id=4ef3d9c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef3d9c5"]])

export default __exports__